<template>
  <top-view>
    <div class="mx-auto text-center create-vacation-box">
      <v-row>
        <v-col sm="6" md="4" lg="3" xl="2" class="mt-4">
          <div class="header-new-vacation">{{ $t("web_apply_vaction") }}</div>
        </v-col>
        <v-col sm="6" md="8" lg="9" xl="10" v-if="windowWidth>600" class="line-new-vacation"></v-col>
      </v-row>
      <v-container fluid class="mx-auto text-center">
        <v-row align="center" justify="center">
          <v-col cols="12" md="6" sm="12" xs="12">
            <v-form ref="form">
              <v-container class="mx-1 container-day">
                <v-row>
                <v-col lg="6" md="12" sm="12" cols="12" class="select-box padding-bottom-0">
                  <p class="text-left">
                    {{ $t("register_vacation_type") }}
                    <img
                      class="image"
                      src="../../assets/required.png"
                      width="12"
                      height="12"
                      alt="required"
                    />
                  </p>
                  <v-list-item-subtitle class="select-right">
                    <v-select
                      v-model="select_type"
                      :items="type_list"
                      item-text="name"
                      item-value="id"
                      filled
                      @change="onTypeSelected"
                    >
<template slot='item' slot-scope='{ item }'>
  <div class="select-two-line-three-dots">
    {{ item.name }}
  </div>
</template>
                    </v-select>
                  </v-list-item-subtitle>
                  
                </v-col>
                <v-col lg="6" md="12" sm="12" cols="12" class="select-box padding-right-5">
                  <p class="text-left">
                    {{ $t("register_vacation_reason") }}
                    <img
                      class="image"
                      src="../../assets/required.png"
                      width="12"
                      height="12"
                      alt="required"
                    />
                  </p>
                  <v-list-item-subtitle class="select-left">
                    <v-select
                      v-model="select_reason"
                      :items="reason_list"
                      item-text="name"
                      item-value="id"
                      filled
                    >
<template slot='item' slot-scope='{ item }'>
  <div class="select-two-line-three-dots">
    {{ item.name }}
  </div>
</template>
                    </v-select>
                  </v-list-item-subtitle>
                </v-col>
              </v-row>
              </v-container>
              <div v-if='!isSwitcherDisable' class="all-day">
                <span  class="in-all-day">{{ $t("register_vacation_all_day") }}</span>
                <v-switch  v-model="switch_all_day" color="#5E81ED" class="ml-15 switch-all-day" ></v-switch>
              </div>
              <div v-else style="height:15px;"></div>
              <v-container class="mx-1 container-day">
                <v-row>
                  <v-col cols="7" md="7" lg="3" sm="7" v-if="switch_all_day==false">
                    <div class="from-day">
                      {{ $t("register_vacation_from") }}
                      <img class="image" src="../../assets/required.png" width="12" height="12" alt="required" />
                    </div>
                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="date1"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              filled
                              dense
                            ></v-text-field>
</template>
                      <v-date-picker :locale="vuetifyLocale" v-model="date1" @input="menu1 = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="6" xs="12" class="padding-right-0" v-else>
                    <div class="from-day-allday">
                      {{ $t("register_vacation_from") }}
                      <img
                        class="from-image"
                        src="../../assets/required.png"
                        width="12"
                        height="12"
                        alt="required"
                      />
                    </div>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      min-width="290px"
                    >
<template v-slot:activator="{ on, attrs }">
  <v-text-field v-model="date1" readonly v-bind="attrs" v-on="on" filled dense>
  </v-text-field>
</template>
                      <v-date-picker v-model="date1" @input="menu1 = false" @change="onFromDateSelect"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col style="margin-top:2px;padding-right:14px;" cols="5" md="5" lg="3" sm="5" v-if="switch_all_day==false">
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      max-width="290px"
                      min-width="290px"
                    >
<template v-slot:activator="{ on, attrs }">
  <v-text-field v-model="time1" readonly v-bind="attrs" v-on="on" filled dense>
  </v-text-field>
</template>
                      <v-time-picker
                        v-if="menu3"
                        v-model="time1"
                        format="24hr"
                        full-width
                        @click:minute="$refs.menu3.save(time1)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>

                  <v-col
                    cols="7"
                    md="7"
                    lg="3"
                    sm="7"
                    class="relative-to"
                    v-if="switch_all_day==false"
                  >
                    <div class="to-day">
                      {{ $t("register_vacation_to") }}
                      <img
                        class="image"
                        src="../../assets/required.png"
                        width="12"
                        height="12"
                        alt="required"
                      />
                    </div>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      min-width="290px"
                    >
<template v-slot:activator="{ on, attrs }">
  <v-text-field v-model="date2" readonly v-bind="attrs" v-on="on" filled dense>
  </v-text-field>
</template>
                      <v-date-picker :locale="vuetifyLocale" v-model="date2" @input="menu2 = false" ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" lg="6" md="12" sm="6" xs="12" class="to-day-all" v-else>
                    <div class="label-to" v-if="isSelectTypeValid()">
                      {{ $t("register_vacation_to") }}
                      <img
                        class="image-to-require"
                        src="../../assets/required.png"
                        width="12"
                        height="12"
                        alt="required"
                      />
                    </div>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      min-width="290px"
                      v-if="isSelectTypeValid()"
                    >
<template v-slot:activator="{ on, attrs }">
  <v-text-field v-model="date2" readonly v-bind="attrs" v-on="on" filled dense>
  </v-text-field>
</template>
                      <v-date-picker v-model="date2" @input="menu2 = false" @change="onToDateSelect"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col style="margin-top:2px;padding-right:14px;" cols="5" md="5" lg="3 " sm="5" v-if="switch_all_day==false">
                    <v-menu
                      ref="menu"
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      max-width="290px"
                      min-width="290px"
                    >
<template v-slot:activator="{ on, attrs }">
  <v-text-field v-model="time2" readonly v-bind="attrs" v-on="on" filled dense>
  </v-text-field>
</template>
                      <v-time-picker
                        v-if="menu4"
                        v-model="time2"
                        format="24hr"
                        full-width
                        @click:minute="$refs.menu.save(time2)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="mx-1 padding-right-2">
                <v-list-item-title class="text-left">{{ $t("register_vacation_description") }}<img
                      class="image"
                      src="../../assets/required.png"
                      width="12"
                      height="12"
                      alt="required"
                /></v-list-item-title>
                <v-textarea
                  flat
                  no-resize
                  rows="5"
                  background-color="#F4F4F4"
                  v-model="description"
                  maxlength="150"
                  @blur="hideKeyboard"
                ></v-textarea>
              </v-container>
              <v-col class="text-right">
                <v-btn
                  depressed
                  style="width: 125px;height: 35px;margin-right:15px !important;"
                  color="#E561A9"
                  class="mx-2 px-10 mt-10"
                  dark
                  v-on:click="cancelClicked"
                >
                  <b>{{ $t("common_cancel") }}</b>
                </v-btn>
                <v-btn
                  depressed
                  style="width: 125px;height: 35px; margin-right:8px !important; ;"
                  color="#5E81ED"
                  class="mx-2 px-10"
                  dark
                  v-on:click="createVacation"
                >
                  <b v-if="isEditting">{{ $t("common_update") }}</b>
                  <b v-else>{{ $t("register_vacation_register") }}</b>
                </v-btn>
              </v-col>
            </v-form>
          </v-col>
          <v-col cols="12" md="6" class="text-center" v-if="windowWidth>960">
            <img
              style="max-width: 90%;height:auto; width:auto; "
              src="../../assets/applyvacation_bg.png"
              width="550"
              height="290"
              alt="Apply vacation"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </top-view>
</template>

<script>
import TopView from "../../components/commonui/topView/TopViewFullScreen";
import { mapState, mapGetters, mapMutations} from "vuex";
import { ListEvents, TabNames, resizeMixin, ScreenNames} from "@/utilities/CommonUtilities";
import moment from "moment";
export default {
  mixins: [resizeMixin],
  components: {
    TopView
  },
  data: function() {
    return {
      date1: null,
      date2: null,
      time: null,
      menu1: false,
      time1: null,
      time2: null,
      menu2: false,
      menu3: false,
      modal3: false,
      menu4: false,
      modal4: false,
      isEditting: false,
      switch_all_day: false,
      select: {
        state: "Florida",
        abbr: "FL"
      },
      select_type: null,
      type_list: [],
      select_reason: null,
      vacationInfo: null,
      reason_list: [],
      windowWidth: window.innerWidth,
      description: null,
      isChangeSuccessed: false,
      isDestroyed: false,
      isSwitcherDisable: false
    };
  },
  computed: {
    ...mapState(["userInfo", "token"]),
    ...mapGetters([
      "getListType",
      "getListReasonByTypeID",
      "getDurationByTypeID"
    ]),
    ...mapState({
      currentScreen: state => state.homeData.currentScreen,
      selectedDate: state => state.homeData.selectedDate
    }),
    ...mapGetters({
          getFilterInfo: "homeData/getFilterInfo"
        }),
    ...mapGetters({
      getVacationById: "homeData/getVacationById"
    }),
    vuetifyLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations({
      saveFilter: "homeData/saveFilter",
      setCurrentTab: "homeData/setCurrentTab",
      setSelectedTab: "homeData/setSelectedTab",
      setCurrentScreen: "homeData/setCurrentScreen",
    }),
    initSetup(route) {
      if (route.params.option == "create") {
        this.isEditting = false;
      } else {
        this.isEditting = true;
      }
    },
    hideKeyboard() {
      document.activeElement.blur();
    },
    onFromDateSelect() {
      if (this.isSwitcherDisable) {
        this.date2 = this.date1;
      }
    },

    onToDateSelect() {
      if (this.isSwitcherDisable) {
        this.date1 = this.date2;
      }
    },
    isSelectTypeValid() {
      return this.select_type !== 4;
    },
    onTypeSelected() {
      this.select_reason = null;
      this.reason_list = [];
      let duration = this.getDurationByTypeID(this.select_type);
      if (duration == 1) {
        this.isSwitcherDisable = true;
        this.switch_all_day = true;
        this.date2 = this.date1;
      } else {
        this.isSwitcherDisable = false;
      }
      let listReason = this.getListReasonByTypeID(this.select_type);
      let reasons = listReason.map(t => {
        var name = "";
        if (this.$i18n.locale == "ja") {
          name = t.name_jp;
        } else if (this.$i18n.locale == "vi") {
          name = t.name_vi;
        } else {
          name = t.name_en;
        }
        return {
          name: name,
          id: t.id
        };
      });
      this.reason_list = [...this.reason_list, ...reasons];
    },
    async createVacation() {
      if (!this.select_type) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("register_vacation_type_error")
        );
        return;
      }
      if (!this.select_reason) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("register_vacation_reason_error")
        );
        return;
      }
      if (!this.date1) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("web_register_vacation_from_date_error")
        );
        return;
      }
      if (!this.switch_all_day && !this.time1) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("web_register_vacation_from_time_error")
        );
        return;
      }
      if (!this.date2) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("web_register_vacation_to_date_error")
        );
        return;
      }
      if (!this.switch_all_day && !this.time2) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("web_register_vacation_to_time_error")
        );
        return;
      }

      let fromDate, toDate;
      if (this.switch_all_day) {
        fromDate = this.date1 + " 00:00";
        toDate = this.date2 + " 23:59";
      } else {
        fromDate = this.date1 + " " + this.time1;
        toDate = this.date2 + " " + this.time2;
      }

      var fromDateMoment = moment(fromDate, "YYYY-MM-DD HH:mm");
      var toDateMoment = moment(toDate, "YYYY-MM-DD HH:mm");
      if (!fromDateMoment.isBefore(toDateMoment)) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("register_vacation_date_time_error_not_before")
        );
        return;
      }
      if (toDateMoment.diff(fromDateMoment, "days") > 30) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("register_vacation_date_time_error_too_much")
        );
        return;
      }

      if (!this.description || (this.description && this.description.trim().length < 8)) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("register_vacation_description_error")
        );
        return;
      }
      
      this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      var dictParams;
      if (this.isEditting) {
        dictParams = {
          id: this.$route.params.vationid,
          title: "null",
          from_date: fromDate,
          to_date: toDate,
          description: this.description,
          all_day: this.switch_all_day ? "0" : "1",
          user_id: this.userInfo.userID,
          public: "0",
          token: this.token,
          reason_id: this.select_reason,
          type_id: this.select_type
        };
      } else {
        dictParams = {
          title: "null",
          from_date: fromDate,
          to_date: toDate,
          description: this.description,
          all_day: this.switch_all_day ? "0" : "1",
          user_id: this.userInfo.userID,
          public: "0",
          token: this.token,
          reason_id: this.select_reason,
          type_id: this.select_type
        };
      }

      try {
        if (this.isEditting) {
          await this.dataSource.postData(
            this.dataSource.editVacationURL,
            dictParams
          );
        } else {
          await this.dataSource.postData(
            this.dataSource.registerVacation,
            dictParams
          );
        }
        this.isChangeSuccessed = true;
        if (this.isEditting) {
          this.notifyBus.$emit(
            ListEvents.showOKDialog,
            this.$i18n.t("common_updateSuccessfully")
          );
        } else {
          this.notifyBus.$emit(
            ListEvents.showOKDialog,
            this.$i18n.t("register_vacation_register_success")
          );
        }
        //redirect mylist screen.
        this.setSelectedTab(TabNames.Requesting);
        if(this.isMobile) this.setCurrentScreen(ScreenNames.ListVacation);
        let filterInfoTemp = this.getFilterInfo;
        filterInfoTemp.color = 'blue';
        this.saveFilter(filterInfoTemp);
      } catch (ex) {
        if (ex.response != undefined && ex.response.status == 409) {
          this.notifyBus.$emit(
            ListEvents.showOKDialog,
            this.$i18n.t("register_vacation_duplicate_error")
          );
        } else {
          this.notifyBus.$emit(
            ListEvents.showOKDialog,
            this.$i18n.t("common_unknown_error")
          );
        }
        return;
      } finally {
        this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
      }
    },
    cancelClicked() {
      this.transitScreenForDevice();
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    transitScreenForDevice(){
      if(this.currentScreen === ScreenNames.ListVacation) {
        this.$router.push({
          name: "listVacation",
          params: { option: "list" },
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
      this.$router.go(0);
    },
  },
  created() {
    this.initSetup(this.$route);
    let listTypes = this.getListType.map(t => {
      var name = "";
      if (this.$i18n.locale == "ja") {
        name = t.name_jp;
      } else if (this.$i18n.locale == "vi") {
        name = t.name_vi;
      } else {
        name = t.name_en;
      }
      return {
        duration: t.duration,
        name: name,
        id: t.id
      };
    });
    this.type_list = [...this.type_list, ...listTypes];
    if (this.isEditting) {
      this.vacationInfo = this.getVacationById(this.$route.params.vationid);
      if (
        this.vacationInfo.status != "0" ||
        this.userInfo.userID != this.vacationInfo.user_id
      ) {
        this.$router.push({
          name: "home"
        });
      }
      this.switch_all_day = this.vacationInfo.all_day == "0" ? true : false;
      this.description = this.vacationInfo.description;
      this.select_type = this.vacationInfo.type_id;
      let duration = this.getDurationByTypeID(this.vacationInfo.type_id);
      if (duration == 1) {
        this.isSwitcherDisable = true;
      }
      this.onTypeSelected();
      this.select_reason = this.vacationInfo.reason_id;
      this.date1 = this.vacationInfo.from_date.substring(0, 10);
      this.date2 = this.vacationInfo.to_date.substring(0, 10);
      if (!this.switch_all_day) {
        this.time1 = this.vacationInfo.from_date.substring(10, 16);
        this.time2 = this.vacationInfo.to_date.substring(10, 16);
      }
    } else {
      //set from date is default
      if(this.selectedDate){
        this.date1 = this.selectedDate.substring(0, 10);
        this.date2 = this.selectedDate.substring(0, 10);
      }
    }
    this.notifyBus.$on(ListEvents.tappedOKAction, () => {
      if (!this.isChangeSuccessed || this.isDestroyed) return;
      
      this.transitScreenForDevice();
    });
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.isDestroyed = true;
  },
  inject: ["dataSource", "notifyBus"]
};
</script>

<style scoped>
.line-new-vacation {
  box-shadow: 0 0.5px 0 #c7c7c7;
  height: 1px;
  margin-top: 30px;
}

.header-new-vacation {
  font-size: 1.5rem;
  font-weight: bold;
}

.text-right {
  padding: 0px;
  margin-top: 10px;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  margin: 0px !important;
}

.v-textarea--no-resize >>> textarea {
  padding: 12px !important;
  font-size: 0.825rem;
}

.v-text-field >>> .v-input__slot::before {
  width: 0 !important;
}

.v-list-item .v-list-item__title {
  text-align: left;
  color: #333333;
  margin-bottom: 10px;
}

.container {
  padding: 0px;
}

.v-list-item {
  padding: 0px;
}

.v-text-field >>> .v-input__slot {
  border-radius: 3px !important;
  width: 98%;
}

.switch-all-day {
  margin-left: -10px;
}

.switch-all-day >>> .v-input__slot {
  width: 8%;
}

.col-3 {
  max-width: 23%;
}

.col-6 {
  padding-left: 0px;
  padding-right: 8px;
  /* padding: 12px 0; */
}

.v-application .ma-4 {
  margin: 10px !important;
}

.v-application .ml-15 {
  margin-left: 80px !important;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.col-lg-6,
.col-md-12,
.col-sm-12,
.col-lg-4,
.col-md-7,
.col-sm-7,
.col-7 {
  padding-left: 0px;
  padding-right: 0px;
}

.col-lg-2,
.col-md-5,
.col-sm-5,
.col-5 {
  padding: 10px;
}

@media (min-width: 960px) {
  .col-md-6 {
    max-width: 47%;
  }
}

.container--fluid {
  max-width: 93%;
}

div.v-list-item__title {
  width: 200px !important;
}

.v-list-item__content {
  width: 200px !important;
}

.select-box >>> .v-input__control > .v-input__slot {
  margin: 0;
  max-height: 40px;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
}

.select-box {
  padding-left: 2px;
  padding-top: 0px;
}

.select-box >>> .v-input__icon {
  height: 2px !important;
}

.padding-bottom-0 {
  padding-bottom: 0px;
}

.padding-right-2 {
  padding-right: 2px;
}

.create-vacation-box {
  width: 100%;
  height: 100%;
  background: #ffffff;
}

.all-day {
  position: relative;
  margin-bottom: 15px;
}

.in-all-day {
  position: absolute;
  top: 3px;
  left: 7px;
}

.container-day {
  margin-top: 15px;
  position: relative;
}

.from-day {
  position: absolute;
  top: -25px;
  left: 3px;
}

.image {
  margin-left: 3px;
  margin-right: 5px;
}

.info-require {
  font-size: 10px;
  background-color: #e561a9;
  padding: 4px 5px;
  border-radius: 3px;
  color: white;
}

.padding-right-0 {
  padding-right: 10px;
}

.padding-bottom-10 {
  padding-bottom: 10px;
}

.from-day-allday {
  position: absolute;
  top: -25px;
  left: 3px;
}

.from-image {
  margin-left: 8px;
  margin-right: 8px;
}

.relative-to {
  position: relative;
}

.to-day {
  position: absolute;
  top: -25px;
  left: 0px;
}

.to-day-all {
  padding-left: 0px;
  padding-right: 10px;
  position: relative;
}

.label-to {
  position: absolute;
  top: -25px;
  left: 3px;
}

.image-to-require {
  margin-left: 5px;
  margin-right: 10px;
}

.padding-right-5 {
  padding-right: 5px;
}

.select-two-line-three-dots {
  display: -webkit-box;
  width: 100%;
  max-width: 400px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}

.v-text-field >>> .v-text-field__details {
  margin-bottom: 0px;
}

.v-input--selection-controls {
  margin-top: 0px;
}

.select-left >>> .v-input__control {
  padding-left: 0px;
  padding-right: 4px;
}

.select-right >>> .v-input__control {
  padding-right: 8px;
}
</style>


